import { Client } from "@xmpp/client"
import { Element } from "@xmpp/xml"
import { getAllItems } from "./PubSub"
import { wizardJid } from "@/jidUtils"
import XmppPubSubApi from "../xmppPubSubApi"
import { TrailerLocation } from "@/reducers/trailerLocationsSlice"
import {
  parseTrailerLocationItem,
  TRAILER_GEOLOC_NODE,
} from "@/lib/trailerLocationPubSubParser"

export const retrieveAllTrailerLocations = async (
  xmpp: Client,
): Promise<TrailerLocation[]> => {
  const result = await getAllItems({
    xmpp,
    jid: wizardJid(xmpp.jid!),
    node: TRAILER_GEOLOC_NODE,
    timeout: 20000,
  })

  const items = result
    .getChild("pubsub")
    ?.getChild("items")
    ?.getChildren("item") as Element[] | undefined

  if (!items) return []

  return items
    .map(parseTrailerLocationItem)
    .filter((trailer): trailer is TrailerLocation => Boolean(trailer))
}

export const subscribeToTrailerLocations = async (client: Client) => {
  try {
    await XmppPubSubApi.subscribe(
      window.XMPP!,
      wizardJid(client.jid!),
      TRAILER_GEOLOC_NODE,
    )
  } catch (error: any) {
    // Vhosts without trailer-tracking providers simply have no node yet.
    if (error.condition !== "item-not-found") {
      console.warn(`Error subscribing to ${TRAILER_GEOLOC_NODE}`, error)
    }
  }
}
